import useTranslation from "next-translate/useTranslation";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import Carousel from "shared/components/organisms/Carousel";

interface ICategoriesProps {
  contents: any[];
}
const Categories = ({ contents }: ICategoriesProps) => {
  const { t } = useTranslation();

  function removeDisabledCategories(categories) {
    const activeCategories = [];

    for (let i = 0; i < categories?.length; i += 1) {
      if (categories[i]?.data?.active)
        activeCategories.push(categories[i]?.data);
    }
    return activeCategories;
  }

  return (
    <>
      {removeDisabledCategories(contents)?.length > 0 && (
        <ComponentErrorBoundary>
          <Carousel
            zIndex={30}
            context="category"
            sectionLink="/categories"
            items={removeDisabledCategories(contents)}
            sectionDescription={t("common:seeAllCategories")}
            sectionTitle={t("common:categories")}
          />
        </ComponentErrorBoundary>
      )}
    </>
  );
};

export default Categories;
